function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function validateZipCode(zipCode) {
  return /^\d+$/.test(zipCode);
}

function validateVatNumber(vatNumber) {
  if (!/^\d{11}$/.test(vatNumber)) {
    return false;
  }

  let s = 0;
  for (let i = 0; i <= 9; i += 2) {
    s += parseInt(vatNumber.charAt(i), 10);
  }
  for (let i = 1; i <= 9; i += 2) {
    let c = 2 * parseInt(vatNumber.charAt(i), 10);
    s = s + (c > 9 ? c - 9 : c);
  }
  if ((10 - s % 10) % 10 !== parseInt(vatNumber.charAt(10), 10)) {
    return false;
  }

  return true;
}

function validateTaxCode(taxCode, gender, birthDate) {
  if (!/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(taxCode)) {
    return false;
  }

  let s = 0;
  const set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
  for (let i = 1; i <= 13; i += 2) {
    s += "ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(set2.charAt(set1.indexOf(taxCode.charAt(i))));
  }
  for (let i = 0; i <= 14; i += 2) {
    s += "BAKPLCQDREVOSFTGUHMINJWZYX".indexOf(set2.charAt(set1.indexOf(taxCode.charAt(i))));
  }
  if (s % 26 !== taxCode.charCodeAt(15) - 'A'.charCodeAt(0)) {
    return false;
  }

  const day = parseInt(taxCode.substr(9, 2));
  if (gender && birthDate) {
    if (birthDate.getFullYear() % 100 !== parseInt(taxCode.substr(6, 2))) {
      return false;
    }
    if (birthDate.getMonth() !== 'ABCDEHLMPRST'.indexOf(taxCode.substr(8, 1))) {
      return false;
    }
    if (gender === 'M' && birthDate.getDate() !== day) {
      return false;
    }
    if (gender === 'F' && birthDate.getDate() !== day - 40) {
      return false;
    }
  }
  else if (gender) {
    if (gender === 'M' && day > 31) {
      return false;
    }
    if (gender === 'F' && day <= 31) {
      return false;
    }
  }

  return true;
}

export const validateStep1 = (t, bookingData) => {
  const errorList = {};

  if (!bookingData.type) {
    return false;
  }
  if (!bookingData.code) {
    errorList.code = t('booking.code.invalid');
  }

  if (bookingData.type === 'codice') {
    if (!bookingData.date) {
      errorList.date = t('booking.date.invalid');
    }
  }
  else if (bookingData.type === 'voucher') {
    if (!bookingData.name) {
      errorList.name = t('booking.name.invalid');
    }
    if (!bookingData.surname) {
      errorList.surname = t('booking.surname.invalid');
    }
  }

  return { isValid: Object.keys(errorList).length === 0, errorList };
};

export const validateCustomerForm = (t, customerData) => {
  const isCompany = ['company', 'sole-proprietorship'].includes(customerData.type);
  const isItalia = customerData.nation === 'ITALIA';
  const errorList = {};

  // Type
  if (!customerData.type) {
    errorList.type = t('customer.form.type.invalid');
  }

  // Personal data
  if (['sole-proprietorship', 'individual', 'driver'].includes(customerData.type)) {
    if (!customerData.name) {
      errorList.name = t('customer.form.name.invalid');
    }
    if (!customerData.surname) {
      errorList.surname = t('customer.form.surname.invalid');
    }
    if (!customerData.gender) {
      errorList.gender = t('customer.form.gender.invalid');
    }
    if (!customerData.birthDate) {
      errorList.birthDate = t('customer.form.birthDate.invalid');
    }
    if (!customerData.birthNation) {
      errorList.birthNation = t('customer.form.birthNation.invalid');
    }
    if (!customerData.birthCity) {
      errorList.birthCity = t('customer.form.birthCity.invalid');
    }
    if (isItalia) {
      if (!validateTaxCode(customerData.taxCode, customerData.gender, customerData.birthDate)) {
        errorList.taxCode = t('customer.form.taxCode.invalid');
      }
    }
  }

  // Company data
  if (isCompany) {
    if (!customerData.companyName) {
      errorList.companyName = t('customer.form.companyName.invalid');
    }
    if (customerData.vatNumber === '') {
      errorList.vatNumber = t('customer.form.vatNumber.invalid');
    }
    if (isItalia) {
      if (!validateVatNumber(customerData.vatNumber)) {
        errorList.vatNumber = t('customer.form.vatNumber.invalid');
      }
      if (!customerData.pec && !customerData.SDICode) {
        errorList.pec = t('customer.form.pec.invalid');
        errorList.SDICode = t('customer.form.SDICode.invalid');
      }
      if (customerData.pec && !validateEmail(customerData.pec)) {
        errorList.pec = t('customer.form.email.invalid');
      }
    }
  }

  // Address
  if (!customerData.nation) {
    errorList.nation = isCompany ? t('customer.form.companyNation.invalid') : t('customer.form.nation.invalid');
  }
  if (!customerData.city) {
    errorList.city = isCompany ? t('customer.form.companyCity.invalid') : t('customer.form.city.invalid');
  }
  if (!customerData.address) {
    errorList.address = isCompany ? t('customer.form.companyAddress.invalid') : t('customer.form.address.invalid');
  }
  if (!customerData.streetNumber) {
    errorList.streetNumber = t('customer.form.streetNumber.invalid');
  }
  if (!customerData.zipCode || (isItalia && !validateZipCode(customerData.zipCode))) {
    errorList.zipCode = t('customer.form.zipCode.invalid');
  }

  // Contacts
  if (customerData.type === 'driver') {
    if (customerData.email && !validateEmail(customerData.email)) {
      errorList.email = t('customer.form.email.invalid');
    }
  }
  else {
    if (!customerData.phone) {
      errorList.phone = t('customer.form.phone.invalid');
    }
    if (!customerData.email || !validateEmail(customerData.email)) {
      errorList.email = t('customer.form.email.invalid');
    }
  }

  if (customerData.isDriver) {
    // License
    if (!customerData.licenseNumber) {
      errorList.licenseNumber = t('customer.form.licenseNumber.invalid');
    }
    if (!customerData.licenseCategory) {
      errorList.licenseCategory = t('customer.form.licenseCategory.invalid');
    }
    if (!customerData.licenseIssuedBy) {
      errorList.licenseIssuedBy = isItalia ? t('customer.form.licenseIssuedBy.invalidCity') : t('customer.form.licenseIssuedBy.invalidNation');
    }

    // Document
    if (!customerData.documentType) {
      errorList.documentType = t('customer.form.documentType.invalid');
    }
    if (!customerData.documentNumber) {
      errorList.documentNumber = t('customer.form.documentNumber.invalid');
    }
    if (!customerData.documentIssuedBy) {
      errorList.documentIssuedBy = isItalia ? t('customer.form.documentIssuedBy.invalidCity') : t('customer.form.documentIssuedBy.invalidNation');
    }
    if (!customerData.documentReleaseDate) {
      errorList.documentReleaseDate = t('customer.form.documentReleaseDate.invalid');
    }
    if (!customerData.documentExpirationDate) {
      errorList.documentExpirationDate = t('customer.form.documentExpirationDate.invalid');
    }
  }

  return { isValid: Object.keys(errorList).length === 0, invalidFields: errorList };
};